<div class="{{localService.selectedLanguageCode}}"  *ngIf="localService.languageContent != null && localService.languageContent.table != undefined">
  <div class="banner center" style="max-width:500px;" *ngIf="wrappers !== undefined">
    <div class="row row_header">
      <div class="col-2">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-10">
        {{localService.languageContent.table.title}}
        <div class="icon_action_header">
          <i class="material-icons on_language_changed" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons" (click)="openCreateEditPopup('')" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div class="row styled_row" *ngFor="let item of wrappers">
      <div class="col-2">
        <i class="material-icons button icon_adjust" title="{{item.v5 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onActiveInactiveStatus(item.key)" [ngStyle]="{'color': item.v5 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v5 == '1' ? "toggle_on" : "toggle_off"}}</i>
      </div>
      <div class="col-10">
        <div class="single_line button" (click)="openCreateEditPopup(item.key)">{{item.v4}}</div>
      </div>
    </div>
  </div>
</div>
